//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    catalogIntegration_GetCatalogIntegrationCatalogItemViewerSettings(catalogKey: string, integrationKey: string): Observable<CatalogIntegrationCatalogItemViewerDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogIntegration/catalogItemViewerIntegration/{catalogKey}/{integrationKey}";
        if (catalogKey === undefined || catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        if (integrationKey === undefined || integrationKey === null)
            throw new globalThis.Error("The parameter 'integrationKey' must be defined.");
        url_ = url_.replace("{integrationKey}", encodeURIComponent("" + integrationKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogIntegration_GetCatalogIntegrationCatalogItemViewerSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogIntegration_GetCatalogIntegrationCatalogItemViewerSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogIntegrationCatalogItemViewerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogIntegrationCatalogItemViewerDto>;
        }));
    }

    protected processCatalogIntegration_GetCatalogIntegrationCatalogItemViewerSettings(response: HttpResponseBase): Observable<CatalogIntegrationCatalogItemViewerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogIntegrationCatalogItemViewerDto;
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogIntegration_GetCatalogIntegrationCatalogViewerSettings(catalogKey: string, integrationKey: string): Observable<CatalogIntegrationCatalogViewerDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogIntegration/catalogViewerIntegration/{catalogKey}/{integrationKey}";
        if (catalogKey === undefined || catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        if (integrationKey === undefined || integrationKey === null)
            throw new globalThis.Error("The parameter 'integrationKey' must be defined.");
        url_ = url_.replace("{integrationKey}", encodeURIComponent("" + integrationKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogIntegration_GetCatalogIntegrationCatalogViewerSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogIntegration_GetCatalogIntegrationCatalogViewerSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogIntegrationCatalogViewerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogIntegrationCatalogViewerDto>;
        }));
    }

    protected processCatalogIntegration_GetCatalogIntegrationCatalogViewerSettings(response: HttpResponseBase): Observable<CatalogIntegrationCatalogViewerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogIntegrationCatalogViewerDto;
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogIntegration_GetSingleCatalogKeyAndCatalogItemIdsByCatalogItemGuids(catalogItemGuids: string[]): Observable<CatalogKeyAndCatalogItemIdsDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogIntegration/singleCatalogKeyAndCatalogItemIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(catalogItemGuids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogIntegration_GetSingleCatalogKeyAndCatalogItemIdsByCatalogItemGuids(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogIntegration_GetSingleCatalogKeyAndCatalogItemIdsByCatalogItemGuids(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogKeyAndCatalogItemIdsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogKeyAndCatalogItemIdsDto>;
        }));
    }

    protected processCatalogIntegration_GetSingleCatalogKeyAndCatalogItemIdsByCatalogItemGuids(response: HttpResponseBase): Observable<CatalogKeyAndCatalogItemIdsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogKeyAndCatalogItemIdsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    common_GetCatalogIdByCatalogKeyForPreview(catalogKey: string): Observable<number> {
        let url_ = this.baseUrl + "/api/v3/Common/catalogId/catalogKey/{catalogKey}";
        if (catalogKey === undefined || catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommon_GetCatalogIdByCatalogKeyForPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommon_GetCatalogIdByCatalogKeyForPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCommon_GetCatalogIdByCatalogKeyForPreview(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    common_GetHelpdeskContent(solution: string, helpId: string, language: string): Observable<string> {
        let url_ = this.baseUrl + "/api/v3/Common/getHelpdeskContent/solution/{solution}/id/{helpId}/language/{language}";
        if (solution === undefined || solution === null)
            throw new globalThis.Error("The parameter 'solution' must be defined.");
        url_ = url_.replace("{solution}", encodeURIComponent("" + solution));
        if (helpId === undefined || helpId === null)
            throw new globalThis.Error("The parameter 'helpId' must be defined.");
        url_ = url_.replace("{helpId}", encodeURIComponent("" + helpId));
        if (language === undefined || language === null)
            throw new globalThis.Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommon_GetHelpdeskContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommon_GetHelpdeskContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCommon_GetHelpdeskContent(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    common_GetHelpdeskTopicContent(solution: string, helpId: string, language: string): Observable<string> {
        let url_ = this.baseUrl + "/api/v3/Common/getHelpdeskContent/solution/{solution}/tId/{helpId}/language/{language}";
        if (solution === undefined || solution === null)
            throw new globalThis.Error("The parameter 'solution' must be defined.");
        url_ = url_.replace("{solution}", encodeURIComponent("" + solution));
        if (helpId === undefined || helpId === null)
            throw new globalThis.Error("The parameter 'helpId' must be defined.");
        url_ = url_.replace("{helpId}", encodeURIComponent("" + helpId));
        if (language === undefined || language === null)
            throw new globalThis.Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommon_GetHelpdeskTopicContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommon_GetHelpdeskTopicContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCommon_GetHelpdeskTopicContent(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    common_GetHelpdeskRoute(solution: string, helpId: string, language: string): Observable<string> {
        let url_ = this.baseUrl + "/api/v3/Common/getHelpdeskRoute/solution/{solution}/id/{helpId}/language/{language}";
        if (solution === undefined || solution === null)
            throw new globalThis.Error("The parameter 'solution' must be defined.");
        url_ = url_.replace("{solution}", encodeURIComponent("" + solution));
        if (helpId === undefined || helpId === null)
            throw new globalThis.Error("The parameter 'helpId' must be defined.");
        url_ = url_.replace("{helpId}", encodeURIComponent("" + helpId));
        if (language === undefined || language === null)
            throw new globalThis.Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommon_GetHelpdeskRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommon_GetHelpdeskRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCommon_GetHelpdeskRoute(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contactForm_RefreshCaptcha(): Observable<CaptchaDto> {
        let url_ = this.baseUrl + "/api/v3/ContactForm/refreshCaptcha";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactForm_RefreshCaptcha(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactForm_RefreshCaptcha(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaptchaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaptchaDto>;
        }));
    }

    protected processContactForm_RefreshCaptcha(response: HttpResponseBase): Observable<CaptchaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaptchaDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contactForm_GetContactForm(catalogKey: string): Observable<ContactFormDto> {
        let url_ = this.baseUrl + "/api/v3/ContactForm/{catalogKey}";
        if (catalogKey === undefined || catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactForm_GetContactForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactForm_GetContactForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactFormDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactFormDto>;
        }));
    }

    protected processContactForm_GetContactForm(response: HttpResponseBase): Observable<ContactFormDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactFormDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    contactForm_SendContactForm(catalogKey: string, valuesDto: ContactFormValuesDto): Observable<ContactFormSendResult> {
        let url_ = this.baseUrl + "/api/v3/ContactForm/{catalogKey}";
        if (catalogKey === undefined || catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(valuesDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactForm_SendContactForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactForm_SendContactForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactFormSendResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactFormSendResult>;
        }));
    }

    protected processContactForm_SendContactForm(response: HttpResponseBase): Observable<ContactFormSendResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactFormSendResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    download_GetAttachmentDownloadUri(attachmentId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/v3/Download/attachment/{attachmentId}";
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload_GetAttachmentDownloadUri(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload_GetAttachmentDownloadUri(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownload_GetAttachmentDownloadUri(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    download_GetAttachmentDownloadStream(fileName: string, attachmentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v3/Download/fileName/{fileName}/attachment/{attachmentId}";
        if (fileName === undefined || fileName === null)
            throw new globalThis.Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload_GetAttachmentDownloadStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload_GetAttachmentDownloadStream(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload_GetAttachmentDownloadStream(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    feedback_SendFeedback(dto: SimpleFeedbackDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v3/Feedback/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFeedback_SendFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFeedback_SendFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFeedback_SendFeedback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    infocenter_GetAdminNewsForDialog(): Observable<InhouseNewsDto[]> {
        let url_ = this.baseUrl + "/api/v3/Infocenter/adminNewsDialog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfocenter_GetAdminNewsForDialog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfocenter_GetAdminNewsForDialog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InhouseNewsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InhouseNewsDto[]>;
        }));
    }

    protected processInfocenter_GetAdminNewsForDialog(response: HttpResponseBase): Observable<InhouseNewsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InhouseNewsDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    infocenter_GetAdminNewsIds(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/v3/Infocenter/adminNewsIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfocenter_GetAdminNewsIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfocenter_GetAdminNewsIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processInfocenter_GetAdminNewsIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    infocenter_GetNewsForDialog(): Observable<InhouseNewsDto[]> {
        let url_ = this.baseUrl + "/api/v3/Infocenter/newsDialog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfocenter_GetNewsForDialog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfocenter_GetNewsForDialog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InhouseNewsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InhouseNewsDto[]>;
        }));
    }

    protected processInfocenter_GetNewsForDialog(response: HttpResponseBase): Observable<InhouseNewsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InhouseNewsDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    infocenter_GetNewsIds(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/v3/Infocenter/newsIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfocenter_GetNewsIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfocenter_GetNewsIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processInfocenter_GetNewsIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchFeedbackForm_GetSearchFeedbackFormData(): Observable<SearchFeedbackFormDto> {
        let url_ = this.baseUrl + "/api/v3/SearchFeedbackForm";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFeedbackForm_GetSearchFeedbackFormData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFeedbackForm_GetSearchFeedbackFormData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchFeedbackFormDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchFeedbackFormDto>;
        }));
    }

    protected processSearchFeedbackForm_GetSearchFeedbackFormData(response: HttpResponseBase): Observable<SearchFeedbackFormDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchFeedbackFormDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchFeedbackForm_SendSearchFeedbackForm(valuesDto: SearchFeedbackFormValuesDto): Observable<SearchFeedbackFormSendResult> {
        let url_ = this.baseUrl + "/api/v3/SearchFeedbackForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(valuesDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFeedbackForm_SendSearchFeedbackForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFeedbackForm_SendSearchFeedbackForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchFeedbackFormSendResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchFeedbackFormSendResult>;
        }));
    }

    protected processSearchFeedbackForm_SendSearchFeedbackForm(response: HttpResponseBase): Observable<SearchFeedbackFormSendResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchFeedbackFormSendResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchFeedbackForm_RefreshCaptcha(): Observable<CaptchaDto> {
        let url_ = this.baseUrl + "/api/v3/SearchFeedbackForm/refreshCaptcha";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFeedbackForm_RefreshCaptcha(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFeedbackForm_RefreshCaptcha(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaptchaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaptchaDto>;
        }));
    }

    protected processSearchFeedbackForm_RefreshCaptcha(response: HttpResponseBase): Observable<CaptchaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaptchaDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    survey_GetSurvey(): Observable<SurveyDto> {
        let url_ = this.baseUrl + "/api/v3/Survey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSurvey_GetSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSurvey_GetSurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyDto>;
        }));
    }

    protected processSurvey_GetSurvey(response: HttpResponseBase): Observable<SurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SurveyDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_AddCatalogItemToWatchList(catalogItemGuid?: string | undefined): Observable<WatchListFlatDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/add/catalogItem?";
        if (catalogItemGuid === null)
            throw new globalThis.Error("The parameter 'catalogItemGuid' cannot be null.");
        else if (catalogItemGuid !== undefined)
            url_ += "catalogItemGuid=" + encodeURIComponent("" + catalogItemGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_AddCatalogItemToWatchList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_AddCatalogItemToWatchList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListFlatDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListFlatDto>;
        }));
    }

    protected processWatchList_AddCatalogItemToWatchList(response: HttpResponseBase): Observable<WatchListFlatDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListFlatDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_AddPositionsToWatchList(catalogItemGuids: string[]): Observable<WatchListFlatDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/add/positions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(catalogItemGuids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_AddPositionsToWatchList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_AddPositionsToWatchList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListFlatDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListFlatDto>;
        }));
    }

    protected processWatchList_AddPositionsToWatchList(response: HttpResponseBase): Observable<WatchListFlatDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListFlatDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_CheckForRemoveIfCatalogItemsAreInUserDefinedListByCatalogId(catalogId?: number | undefined): Observable<WatchListCheckDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/check/remove/catalog?";
        if (catalogId === null)
            throw new globalThis.Error("The parameter 'catalogId' cannot be null.");
        else if (catalogId !== undefined)
            url_ += "catalogId=" + encodeURIComponent("" + catalogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_CheckForRemoveIfCatalogItemsAreInUserDefinedListByCatalogId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_CheckForRemoveIfCatalogItemsAreInUserDefinedListByCatalogId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListCheckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListCheckDto>;
        }));
    }

    protected processWatchList_CheckForRemoveIfCatalogItemsAreInUserDefinedListByCatalogId(response: HttpResponseBase): Observable<WatchListCheckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListCheckDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_CheckForRemoveIfCatalogItemIsInUserDefinedList(catalogItemGuid?: string | undefined): Observable<WatchListCheckDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/check/remove/catalogItem?";
        if (catalogItemGuid === null)
            throw new globalThis.Error("The parameter 'catalogItemGuid' cannot be null.");
        else if (catalogItemGuid !== undefined)
            url_ += "catalogItemGuid=" + encodeURIComponent("" + catalogItemGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_CheckForRemoveIfCatalogItemIsInUserDefinedList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_CheckForRemoveIfCatalogItemIsInUserDefinedList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListCheckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListCheckDto>;
        }));
    }

    protected processWatchList_CheckForRemoveIfCatalogItemIsInUserDefinedList(response: HttpResponseBase): Observable<WatchListCheckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListCheckDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_GetWatchListAsFlatList(): Observable<WatchListFlatDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/flatlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_GetWatchListAsFlatList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_GetWatchListAsFlatList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListFlatDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListFlatDto>;
        }));
    }

    protected processWatchList_GetWatchListAsFlatList(response: HttpResponseBase): Observable<WatchListFlatDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListFlatDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_GetWatchListInformation(): Observable<WatchListInformationDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/information";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_GetWatchListInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_GetWatchListInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListInformationDto>;
        }));
    }

    protected processWatchList_GetWatchListInformation(response: HttpResponseBase): Observable<WatchListInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_RemoveAllCatalogItemsFromWatchList(): Observable<WatchListFlatDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/remove/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_RemoveAllCatalogItemsFromWatchList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_RemoveAllCatalogItemsFromWatchList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListFlatDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListFlatDto>;
        }));
    }

    protected processWatchList_RemoveAllCatalogItemsFromWatchList(response: HttpResponseBase): Observable<WatchListFlatDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListFlatDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_RemoveAllUnavailableCatalogItemsFromWatchList(): Observable<WatchListFlatDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/remove/all/unavailable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_RemoveAllUnavailableCatalogItemsFromWatchList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_RemoveAllUnavailableCatalogItemsFromWatchList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListFlatDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListFlatDto>;
        }));
    }

    protected processWatchList_RemoveAllUnavailableCatalogItemsFromWatchList(response: HttpResponseBase): Observable<WatchListFlatDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListFlatDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_RemoveCatalogItemsFromWatchListByCatalogId(catalogId?: number | undefined): Observable<WatchListFlatDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/remove/catalog?";
        if (catalogId === null)
            throw new globalThis.Error("The parameter 'catalogId' cannot be null.");
        else if (catalogId !== undefined)
            url_ += "catalogId=" + encodeURIComponent("" + catalogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_RemoveCatalogItemsFromWatchListByCatalogId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_RemoveCatalogItemsFromWatchListByCatalogId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListFlatDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListFlatDto>;
        }));
    }

    protected processWatchList_RemoveCatalogItemsFromWatchListByCatalogId(response: HttpResponseBase): Observable<WatchListFlatDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListFlatDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_RemoveCatalogItemFromWatchList(catalogItemGuid?: string | undefined): Observable<WatchListFlatDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/remove/catalogItem?";
        if (catalogItemGuid === null)
            throw new globalThis.Error("The parameter 'catalogItemGuid' cannot be null.");
        else if (catalogItemGuid !== undefined)
            url_ += "catalogItemGuid=" + encodeURIComponent("" + catalogItemGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_RemoveCatalogItemFromWatchList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_RemoveCatalogItemFromWatchList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListFlatDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListFlatDto>;
        }));
    }

    protected processWatchList_RemoveCatalogItemFromWatchList(response: HttpResponseBase): Observable<WatchListFlatDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListFlatDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_GetWatchListStructure(structureInfo?: WatchListStructure | undefined): Observable<WatchListDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/structure?";
        if (structureInfo === null)
            throw new globalThis.Error("The parameter 'structureInfo' cannot be null.");
        else if (structureInfo !== undefined)
            url_ += "structureInfo=" + encodeURIComponent("" + structureInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_GetWatchListStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_GetWatchListStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListDto>;
        }));
    }

    protected processWatchList_GetWatchListStructure(response: HttpResponseBase): Observable<WatchListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    watchList_GetWatchListStructureFromEveryone(catalogItemGuids: string[], structureInfo?: WatchListStructure | undefined): Observable<WatchListDto> {
        let url_ = this.baseUrl + "/api/v3/WatchList/structure/everyone?";
        if (structureInfo === null)
            throw new globalThis.Error("The parameter 'structureInfo' cannot be null.");
        else if (structureInfo !== undefined)
            url_ += "structureInfo=" + encodeURIComponent("" + structureInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(catalogItemGuids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWatchList_GetWatchListStructureFromEveryone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWatchList_GetWatchListStructureFromEveryone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WatchListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WatchListDto>;
        }));
    }

    protected processWatchList_GetWatchListStructureFromEveryone(response: HttpResponseBase): Observable<WatchListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WatchListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface CaptchaDto {
    captchaImage: string;
    captchaKey: string;
}

export interface CatalogIntegrationCatalogItemViewerDto {
    neutralDesign: boolean;
}

export interface CatalogIntegrationCatalogViewerDto {
    catalogIntegrationType: CatalogIntegrationType;
    canNavigateToStartingPage: boolean;
    showForeignLanguageCatalogs: boolean;
    showRelatedCatalogs: boolean;
    canHighlightCatalogItem: boolean;
    canSearch: boolean;
    neutralDesign: boolean;
    collapseNavigation: boolean;
}

export enum CatalogIntegrationType {
    None = 0,
    CatalogViewer = 1,
    CatalogItemViewer = 2,
    ExportDialogDeprecated = 3,
    DirectExport = 4,
}

export interface CatalogKeyAndCatalogItemIdsDto {
    catalogKey?: string | undefined;
    catalogItemIds?: number[] | undefined;
}

export enum CatalogViewTreeItemType {
    Unknown = 0,
    Folder = 1,
    FolderWithAttachments = 2,
    TextOrDocument = 3,
    TextOrDocumentWithAttachments = 4,
    Position = 5,
    PositionWithAttachments = 6,
}

export interface ContactFormBaseDto {
    startTime: Date;
    userIdpOrClientId: string;
    catalogItemGuid?: string | undefined;
}

export interface ContactFormDto {
    requestTypes: number;
    professionGroupDtos?: ProfessionGroupDto[] | undefined;
    valuesDto?: ContactFormValuesDto | undefined;
    captcha?: CaptchaDto | undefined;
}

export enum ContactFormSendResult {
    Sent = 0,
    CaptchaValidationFailed = 1,
    CaptchaValidationTimeout = 2,
}

export enum ContactFormType {
    Unknown = 0,
    CatalogContact = 1,
    CatalogItemContact = 2,
    GlobalSearchFeedback = 3,
    CatalogSearchFeedback = 4,
    NewsContact = 5,
    PersonContact = 6,
    DepartmentContact = 7,
}

export interface ContactFormValuesDto extends ContactFormBaseDto {
    type: ContactFormType;
    requestTypes?: number | undefined;
    message?: string | undefined;
    eMail?: string | undefined;
    sendCopy: boolean;
    phone?: string | undefined;
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    company?: string | undefined;
    searchTerm?: string | undefined;
    captchaCode?: string | undefined;
    captchaKey?: string | undefined;
    professionGroup?: number | undefined;
    contactPersonId?: number | undefined;
    editInfos?: { [key: string]: EditInfoDto; } | undefined;
}

export interface EditInfoDto {
    maxLength: number;
    required: boolean;
    readonly: boolean;
    regex?: string | undefined;
}

export enum ExportLimit {
    Limited = 0,
    Unlimited = 1,
}

export interface ExportSettingsDto {
    maxEverybodyPositions: number;
    maxRegisteredUsersPositions: number;
    minPositionsForWarning: number;
    exportLimit: ExportLimit;
}

export enum InhouseNewsBrandType {
    Ade = 0,
    Orca = 1,
}

export enum InhouseNewsCategoryType {
    News = 0,
    DateAndEvents = 1,
    Sustainability = 2,
    NewFeatures = 3,
    Videos = 4,
    Whitepaper = 5,
    NewProduct = 6,
}

export interface InhouseNewsDto {
    id: number;
    type: NewsType;
    title?: string | undefined;
    teaser?: string | undefined;
    text?: string | undefined;
    imageUrl?: string | undefined;
    keywords?: string[] | undefined;
    additionalInformationsUrl?: string | undefined;
    videoUrl?: string | undefined;
    startDate?: Date | undefined;
    endDate: Date;
    originalImageUrl?: string | undefined;
    brand: InhouseNewsBrandType;
    categoryType: InhouseNewsCategoryType;
    isPublicView: boolean;
    isAdminView: boolean;
}

export enum NewsType {
    TextAndImage = 0,
    Video = 1,
}

export enum NotificationLanguage {
    German = 0,
    English = 1,
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export interface ProfessionGroupDto {
    id: number;
    nameResourceKey?: string | undefined;
}

export interface SearchFeedbackFormBaseDto {
    startTime: Date;
    userIdpOrClientId: string;
    catalogItemId?: string | undefined;
}

export interface SearchFeedbackFormDto {
    valuesDto?: SearchFeedbackFormValuesDto | undefined;
    captcha?: CaptchaDto | undefined;
}

export enum SearchFeedbackFormSendResult {
    Sent = 0,
    CaptchaValidationFailed = 1,
    CaptchaValidationTimeout = 2,
}

export interface SearchFeedbackFormValuesDto extends SearchFeedbackFormBaseDto {
    eMail?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;
    captchaCode?: string | undefined;
    captchaKey?: string | undefined;
    sendCopy: boolean;
    language?: NotificationLanguage | undefined;
    editInfos?: { [key: string]: EditInfoDto; } | undefined;
}

export interface SimpleFeedbackDto {
    feedbackKey: string;
    contextUrl?: string | undefined;
    rating: number;
    message?: string | undefined;
}

export interface SurveyDto {
    iframeLinks?: { [key in keyof typeof SurveyLanguage]?: string; } | undefined;
    isActive: boolean;
    version: number;
}

export enum SurveyLanguage {
    German = 0,
    English = 1,
}

export interface UnavailableWatchListItemDto {
    catalogItemTitle?: string | undefined;
    catalogId: number;
}

export interface WatchListCheckDto {
    existsInUserDefinedList: boolean;
    catalogItemTitle?: string | undefined;
    catalogItemCount: number;
}

export interface WatchListDto {
    watchListId: number;
    catalogs?: WatchListItemDto[] | undefined;
    unavailableCatalogItems?: UnavailableWatchListItemDto[] | undefined;
}

export interface WatchListFlatDto {
    tooManyItems: boolean;
    catalogItemGuids?: string[] | undefined;
    currentWatchListItemsCount: number;
}

export interface WatchListInformationDto {
    maxWatchListItems: number;
    watchListVersion?: string | undefined;
    warningFolderCount: number;
    exportSettings?: ExportSettingsDto | undefined;
}

export interface WatchListItemDto {
    title?: string | undefined;
    catalogItemGuid: string;
    id: number;
    catalogKey?: string | undefined;
    type: CatalogViewTreeItemType;
    children?: WatchListItemDto[] | undefined;
}

export enum WatchListStructure {
    Catalog = 0,
    CatalogAndStructure = 1,
    UserDefined = 2,
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}